import React from "react";
import { Button, CircularProgress, Typography, makeStyles } from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";
import RefreshIcon from "@material-ui/icons/Refresh";
import useNow from "../../hooks/useNow";
import { formatDateTime, toDate } from "../../utils/waitingTime";
import { historyStatusTitle } from "../../utils/ticketHistory";

const useStyles = makeStyles(theme => ({
  root: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", padding: "10px 16px", borderBottom: "1px solid " + theme.custom.border, background: theme.custom.surface, flexShrink: 0 },
  icon: { fontSize: 20, color: theme.palette.text.secondary, flexShrink: 0 },
  content: { flex: 1, minWidth: 170 },
  title: { fontSize: ".75rem", fontWeight: 700 },
  message: { fontSize: ".7rem", color: theme.palette.text.secondary, lineHeight: 1.45, overflowWrap: "anywhere" },
  button: { fontSize: ".68rem", whiteSpace: "nowrap", borderRadius: 8 },
}));

const TicketHistoryStatus = ({ history, refreshing, onRefresh }) => {
  const classes = useStyles();
  const retryAt = toDate(history?.nextRetryAt);
  const now = useNow(Boolean(retryAt && retryAt.getTime() > Date.now()));
  if (!history) return null;
  const syncing = refreshing || history.status === "syncing";
  const retrySeconds = retryAt ? Math.max(0, Math.ceil((retryAt.getTime() - now) / 1000)) : 0;
  const message = history.message || "As mensagens já registradas estão preservadas. O WhatsApp pode disponibilizar apenas parte do histórico.";
  return <section className={classes.root} aria-label="Sincronização do histórico">
    {syncing ? <CircularProgress size={18} aria-label="Buscando histórico" /> : <HistoryIcon className={classes.icon} />}
    <div className={classes.content} role="status" aria-live="polite">
      <Typography className={classes.title}>{historyStatusTitle(syncing ? "syncing" : history.status)}</Typography>
      <Typography className={classes.message}>{message}</Typography>
    </div>
    <Button className={classes.button} size="small" color="primary" variant="outlined" startIcon={!syncing && <RefreshIcon />} disabled={syncing || retrySeconds > 0} onClick={onRefresh} title={retrySeconds ? "Nova tentativa disponível em " + formatDateTime(retryAt) : "Consultar o histórico que o WhatsApp disponibiliza"}>
      {syncing ? "Atualizando…" : retrySeconds ? "Aguarde " + (retrySeconds >= 60 ? Math.ceil(retrySeconds / 60) + " min" : retrySeconds + " s") : "Atualizar histórico"}
    </Button>
  </section>;
};
export default TicketHistoryStatus;
